import Box from '@mui/material/Box';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import { useNavigate } from "react-router-dom";
import "./ServiceBox.css"
 

export const ServicesBox = ()=>{
    const navigate = useNavigate();
    return(
        // <div style={{marginTop:"-2rem ", marginBottom:"2rem"}} >
        //     <h3 style={{color:"white" , textDecoration:"#14c3c7 underline", textAlign:"center"}}>OUR SERVICES</h3>

        //     <div style={{display:"flex" ,marginBottom:"2rem",justifyContent:"center"}}>
        //       <div className='box' onClick={()=>navigate("/services")} style={{marginRight:"3rem"}}>
        //         <MiscellaneousServicesIcon style={{fontSize:"4rem", color:"white", margin:"2rem"}}/>
        //         <p style={{color:"white", marginLeft:"2rem" , fontWeight:400}} className='btnn'>Services</p>
        //       </div>

        //       <div className='box' onClick={()=>navigate("/supply")} style={{marginRight:"3rem"}}>
        //         <PrecisionManufacturingIcon style={{fontSize:"4rem", color:"white", margin:"2rem"}}/>
        //         <p style={{color:"white", marginLeft:"2rem", fontWeight:400}}>Supply</p>
        //     </div>
        //   </div>
        // </div>
        <div className='div-container'>
          <div className='divv'>
            <div className='box' onClick={()=>navigate("/services")}>
              <img src='../img/iconImage/service.png'/>
              <p>Service</p>
            </div>
            <div className='box' onClick={()=>navigate("/supply")}>
            <img src='../img/iconImage/supply.png'/>
              <p>Supply</p>
            </div>
          </div>
        </div>
    )
}